import { Dispatch, SetStateAction } from "react";

type FunctionType = <T>(
    value: T,
    setValue: Dispatch<SetStateAction<T[]>>
) => void;

export const handleArrayStateChange: FunctionType = (value, setValue) => {
    setValue(prevState => {
        const index = prevState.indexOf(value);
        if (index === -1) {
            return [...prevState, value];
        }
        return prevState.filter(item => item !== value);
    });
};
